import * as LucideIcons from "lucide-react"
import { ComponentType } from "react"

// Define the supported icon names based on the data
type IconName =
  | "ac"
  | "pool"
  | "tree"
  | "gym"
  | "shield"
  | "car"
  | "ceiling"
  | "playground"
  | "garage"
  | "disabled-access"
  | "parking"
  | "pet"
  | "fire"
  | "elevator"
  | "smart-home"
  | "people"
  | "wifi"

// Map the icon names from our data to Lucide icon components
const iconMap: Record<IconName, keyof typeof LucideIcons> = {
  ac: "Wind",
  pool: "Droplets",
  tree: "Trees",
  gym: "Dumbbell",
  shield: "Shield",
  car: "Car",
  ceiling: "ArrowUp",
  playground: "Gamepad2",
  garage: "Warehouse",
  "disabled-access": "Accessibility",
  parking: "ParkingCircle",
  pet: "Dog",
  fire: "Flame",
  elevator: "ArrowUpDown",
  "smart-home": "Home",
  people: "Users",
  wifi: "Wifi",
}

interface AmenityIconProps {
  name: IconName
  className?: string
  size?: number
}

const AmenityIcon = ({ name, className = "", size = 18 }: AmenityIconProps) => {
  const iconKey = iconMap[name] || "HelpCircle"

  // Access the icon component dynamically
  const IconComponent = LucideIcons[iconKey] as ComponentType<{
    size: number
    className?: string
    strokeWidth?: number
  }>

  // Return the icon component as JSX
  return <IconComponent size={size} className={className} strokeWidth={1.5} />
}

export default AmenityIcon
